/*
+---------------------------------------------------------+
      Spiced up with love and buzzwoo Theme Sauce
     E-Com Kitchen | Flavor Boost | https://buzzwoo.de
+---------------------------------------------------------+

  Enhancement: PDP-Conversion (ClickUp z929e7fbp3)
  - Preis im Kauf-Button bei Variantenwechsel aktualisieren
  - Sticky-Kaufleiste <bw-eastsmoke-sticky-atc> (nur mobil < 750 px)
  Base: Sense 11.0.0 – nutzt pubsub (PUB_SUB_EVENTS.variantChange) aus global.js,
  global.js selbst bleibt unverändert.

  Werte kommen aus dem server-gerenderten Section-HTML, das Sense beim
  Variantenwechsel ohnehin lädt (event.data.html) – kein Money-Formatting im JS.

  Performance (INP-Reserve): kein Scroll-/Resize-Listener, kein ResizeObserver.
  Sichtbarkeit nur über IntersectionObserver auf den Kauf-Button,
  Warenkorb-Schublade über MutationObserver (class-Attribut).
*/

(function () {
  if (window.bwEastsmokePdp) return;
  window.bwEastsmokePdp = true;

  const MOBILE = window.matchMedia('(max-width: 749px)');
  // Fixe Widgets, die die Leiste nicht verdecken darf → werden angehoben, solange sie sichtbar ist
  const LIFT_ROOTS = ['shopify-chat', '[id^="trustbadge-container"]'];
  // Alle Widgets heben über dieselbe Variable an; Chat offen setzt sie per CSS auf 0
  const LIFT_TRANSLATE = '0 calc(-1 * var(--bw-eastsmoke-sticky-atc-lift, 0px))';

  // Growave (Punkteprogramm, Geschenk-Icon): Launcher und Popup liegen beide position: fixed
  // im Shadow DOM unter einem fixen 0-px-Wrapper. Ein translate auf dem Wrapper macht ihn zum
  // Containing Block → Launcher springt nach rechts, Popup kollabiert auf 0 px Höhe.
  // Deshalb nur den Launcher selbst anheben – per Style im Shadow Root, weil Growave (Svelte)
  // den Launcher nach dem Schließen des Popups neu erzeugt. Die Variable erbt durch den Shadow Root.
  const GROWAVE_ROOTS = '.gw-widget-placeholder-BL-wrapper, .gw-widget-placeholder-BR-wrapper';
  const GROWAVE_LIFT_CSS =
    `.gw-rd-popup-widget-launcher{translate:${LIFT_TRANSLATE};transition:translate .2s ease}`;

  function syncText(html, selector) {
    const current = document.querySelector(selector);
    const next = html.querySelector(selector);
    if (!current || !next) return;
    current.textContent = next.textContent;
    current.hidden = next.hidden;
  }

  class BwEastsmokeStickyAtc extends HTMLElement {
    connectedCallback() {
      // Aus dem Section-DOM lösen, damit kein transformierter Vorfahr position: fixed bricht
      // (appendChild löst connectedCallback erneut aus → Init erst danach)
      if (this.parentElement !== document.body) {
        // Theme-Editor rendert die Section neu → Vorgänger-Leiste entfernen
        document
          .querySelectorAll(`body > bw-eastsmoke-sticky-atc[data-section="${this.dataset.section}"]`)
          .forEach((old) => old.destroy && old.destroy());
        document.body.appendChild(this);
        return;
      }
      if (this.initialized) return;
      this.initialized = true;

      this.sectionId = this.dataset.section;
      this.inlineButton = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
      if (!this.inlineButton) return;

      this.pastButton = false;
      this.drawerOpen = false;
      this.visible = false;

      // Root nach unten „unendlich“ verlängert: nicht-intersecting heißt dann ausschließlich
      // „Button liegt oberhalb des Viewports“. Ohne das feuert der Observer bei einem Sprung
      // von oberhalb nach unterhalb (z. B. schnelles Hochwischen) nicht, weil beide Zustände
      // nicht-intersecting sind.
      this.observer = new IntersectionObserver(
        ([entry]) => {
          this.pastButton = !entry.isIntersecting;
          this.update();
        },
        { rootMargin: '0px 0px 100000px 0px' }
      );
      this.observer.observe(this.inlineButton);

      const drawer = document.querySelector('cart-drawer');
      if (drawer) {
        this.drawerObserver = new MutationObserver(() => {
          this.drawerOpen = drawer.classList.contains('active');
          this.update();
        });
        this.drawerObserver.observe(drawer, { attributes: true, attributeFilter: ['class'] });
      }

      // Ladezustand des Kauf-Buttons spiegeln: Sense setzt .loading synchron im Submit-Handler
      // und entfernt es im finally. Ohne sichtbares Feedback an der Leiste gäbe es bis zum
      // Öffnen der Warenkorb-Schublade keinen neuen Frame (schlechtes INP + keine Rückmeldung).
      this.button = this.querySelector('.bw-eastsmoke-sticky-atc__button');
      this.spinner = this.button && this.button.querySelector('.loading-overlay__spinner');
      // Submit über ein synthetisches submit-Event auf dem Sense-Formular (product-form.js
      // ruft preventDefault und schickt per fetch ab). Ein nativer Submit (type=submit +
      // form-Attribut oder requestSubmit) von außerhalb des Formulars hielt in Chrome den
      // nächsten Frame bis zum Ende von /cart/add zurück: gemessen ~1,15 s Event-Duration
      // vs. 80 ms am Kauf-Button (Storefront-Preview, CPU 4x gedrosselt).
      this.form = document.getElementById(this.button ? this.button.dataset.form : '');
      if (this.button && this.form) {
        this.button.addEventListener('click', () => {
          if (this.button.disabled || this.button.getAttribute('aria-disabled') === 'true') return;
          this.form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        });
      }

      this.loadingObserver = new MutationObserver(() => this.syncLoading());
      this.loadingObserver.observe(this.inlineButton, { attributes: true, attributeFilter: ['class', 'aria-disabled'] });

      this.onMediaChange = () => this.update();
      MOBILE.addEventListener('change', this.onMediaChange);
      this.syncUnit();
    }

    syncLoading() {
      if (!this.button) return;
      const loading = this.inlineButton.classList.contains('loading');
      this.button.classList.toggle('loading', loading);
      if (this.spinner) this.spinner.classList.toggle('hidden', !loading);
      // aria-disabled 1:1 spiegeln – Sense lässt es nach einem Cart-Fehler stehen
      if (this.inlineButton.getAttribute('aria-disabled') === 'true') {
        this.button.setAttribute('aria-disabled', 'true');
      } else {
        this.button.removeAttribute('aria-disabled');
      }
    }

    destroy() {
      if (this.observer) this.observer.disconnect();
      if (this.loadingObserver) this.loadingObserver.disconnect();
      if (this.drawerObserver) this.drawerObserver.disconnect();
      if (this.consentObserver) this.consentObserver.disconnect();
      if (this.onMediaChange) MOBILE.removeEventListener('change', this.onMediaChange);
      document.documentElement.classList.remove('bw-eastsmoke-sticky-atc--visible');
      document.documentElement.style.removeProperty('--bw-eastsmoke-sticky-atc-lift');
      this.remove();
    }

    // Pandectes-Cookie-Banner offen? (custom.css setzt pandectes-cmp auf z-index: 1,
    // die Leiste läge darüber → solange der Banner offen ist, bleibt die Leiste weg)
    consentOpen() {
      const cmp =
        document.querySelector('pandectes-cmp[data-active-instance="true"]') ||
        document.querySelector('pandectes-cmp');
      if (!cmp || !cmp.shadowRoot) return false;
      if (!this.consentObserver) {
        this.consentObserver = new MutationObserver(() => this.update());
        this.consentObserver.observe(cmp.shadowRoot, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['class', 'style', 'hidden'],
        });
      }
      const banner = cmp.shadowRoot.querySelector('.inner');
      if (!banner || banner.getClientRects().length === 0) return false;
      const style = getComputedStyle(banner);
      return style.visibility !== 'hidden' && style.opacity !== '0';
    }

    update() {
      const show = MOBILE.matches && this.pastButton && !this.drawerOpen && !this.consentOpen();
      if (show === this.visible) return;
      this.visible = show;

      this.classList.toggle('is-visible', show);
      this.setAttribute('aria-hidden', String(!show));
      this.toggleAttribute('inert', !show);

      const root = document.documentElement;
      if (show) {
        this.liftWidgets();
        root.style.setProperty('--bw-eastsmoke-sticky-atc-lift', `${this.offsetHeight}px`);
      } else {
        root.style.removeProperty('--bw-eastsmoke-sticky-atc-lift');
        document.querySelectorAll('.bw-eastsmoke-lift').forEach((node) => node.style.removeProperty('translate'));
      }
      root.classList.toggle('bw-eastsmoke-sticky-atc--visible', show);
    }

    liftWidgets() {
      // Nur fixe Blätter anheben: Ein fixes Element mit fixen Nachfahren würde durch translate deren
      // Containing Block (Trusted-Shops-Container ist 0 px groß → Badge landete oberhalb des Viewports).
      // Bei jedem Einblenden neu ermitteln, weil die Widgets ihr Markup nachträglich austauschen.
      LIFT_ROOTS.forEach((selector) => {
        document.querySelectorAll(selector).forEach((el) => {
          const fixed = [el, ...el.querySelectorAll('*')].filter((node) => getComputedStyle(node).position === 'fixed');
          fixed
            .filter((node) => !fixed.some((other) => other !== node && node.contains(other)))
            .forEach((node) => {
              node.classList.add('bw-eastsmoke-lift');
              // Inline + !important: Trusted Shops setzt `all: initial !important` auf den Badge,
              // dagegen kommt keine Stylesheet-Regel an
              node.style.setProperty('translate', LIFT_TRANSLATE, 'important');
            });
        });
      });

      document.querySelectorAll(GROWAVE_ROOTS).forEach((wrapper) => {
        wrapper.querySelectorAll('*').forEach((host) => {
          const shadow = host.shadowRoot;
          if (!shadow || shadow.querySelector('style[data-bw-eastsmoke-lift]')) return;
          const style = document.createElement('style');
          style.dataset.bwEastsmokeLift = '';
          style.textContent = GROWAVE_LIFT_CSS;
          shadow.appendChild(style);
        });
      });
    }

    // Grundpreis der Leiste = Grundpreis der gewählten Kachel (falls vorhanden)
    syncUnit() {
      const unit = this.querySelector('.bw-eastsmoke-sticky-atc__unit');
      if (!unit) return;
      const checked = document.querySelector(`#variant-radios-${this.sectionId} input[type="radio"]:checked`);
      const label = checked && document.querySelector(`label[for="${checked.id}"] .bw-eastsmoke-tile__unit`);
      unit.textContent = label ? label.textContent.trim() : '';
      unit.hidden = !label;
    }

    onVariantChange(html) {
      const base = `bw-eastsmoke-sticky-atc[data-section="${this.sectionId}"]`;
      syncText(html, `${base} .bw-eastsmoke-sticky-atc__variant`);
      syncText(html, `${base} .bw-eastsmoke-sticky-atc__price`);

      const nextButton = html.querySelector(`${base} .bw-eastsmoke-sticky-atc__button`);
      if (nextButton && this.button) {
        const label = this.button.querySelector('.bw-eastsmoke-sticky-atc__label');
        const nextLabel = nextButton.querySelector('.bw-eastsmoke-sticky-atc__label');
        if (label && nextLabel) label.textContent = nextLabel.textContent.trim();
        this.button.disabled = nextButton.disabled;
      }
      this.syncUnit();
    }
  }

  if (!customElements.get('bw-eastsmoke-sticky-atc')) {
    customElements.define('bw-eastsmoke-sticky-atc', BwEastsmokeStickyAtc);
  }

  function onVariantChange(event) {
    if (!event || !event.data || !event.data.html) return;
    const { sectionId, html } = event.data;
    syncText(html, `#ProductSubmitButton-${sectionId} .bw-eastsmoke-atc-price`);
    document
      .querySelectorAll(`bw-eastsmoke-sticky-atc[data-section="${sectionId}"]`)
      .forEach((bar) => bar.onVariantChange && bar.onVariantChange(html));
  }

  // Fehler beim Hinzufügen (z. B. Bestand überschritten) zeigt Sense nur am Kauf-Button an.
  // Kam der Klick aus der sichtbaren Leiste, die Meldung ins Bild holen.
  function onCartError() {
    document.querySelectorAll('bw-eastsmoke-sticky-atc.is-visible').forEach((bar) => {
      const error = document.querySelector(
        `#MainProduct-${bar.dataset.section} .product-form__error-message-wrapper`
      );
      if (error) error.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }

  function init() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.variantChange, onVariantChange);
    subscribe(PUB_SUB_EVENTS.cartError, onCartError);

    // Theme-Editor: Section entfernt → zugehörige Leiste aus dem body räumen
    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:section:unload', (event) => {
        document
          .querySelectorAll(`body > bw-eastsmoke-sticky-atc[data-section="${event.detail.sectionId}"]`)
          .forEach((bar) => bar.destroy && bar.destroy());
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
